var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"margin-top":"30px"},attrs:{"type":"flex"}},[_c('MenuEditor'),_c('GreetingEditor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }